module.exports = __webpack_public_path__ + "static/media/photo85.d51de9f2.jpg";